/* Sauna product pages: finish and view toggles, and running costs that follow the heater picked in the buy box. */
(function () {
  'use strict';
  var root = document.getElementById('hx-root');
  if (!root || !root.classList.contains('sx') || root.getAttribute('data-sx-on')) return;
  root.setAttribute('data-sx-on', '1');

  function toggles(sel, attr, prefix) {
    var btns = root.querySelectorAll(sel);
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute(attr);
        Array.prototype.forEach.call(btns, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        Array.prototype.forEach.call(root.querySelectorAll('[id^="' + prefix + '"]'), function (el) {
          el.classList.toggle('is-off', el.id !== prefix + v);
        });
      });
    });
  }
  toggles('[data-sx-f]', 'data-sx-f', 'sx-f-');
  toggles('[data-sx-v]', 'data-sx-v', 'sx-v-');
  toggles('[data-sx-r]', 'data-sx-r', 'sx-r-');

  // First session: when the sauna is sold with both heater types, follow the heater picked in the buy box.
  var rBtns = root.querySelectorAll('[data-sx-r]');
  function ritualFollow() {
    if (!rBtns.length) return;
    var picked = document.querySelector('.ol-sauna-heater__input:checked');
    if (!picked) return;
    var card = root.querySelector('[data-sx-heater="' + picked.value + '"]');
    if (!card) return;
    var want = card.getAttribute('data-wood') === '1' ? 'wood' : 'electric';
    var btn = root.querySelector('[data-sx-r="' + want + '"]');
    if (btn && btn.getAttribute('aria-pressed') !== 'true') btn.click();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ol-sauna-heater__input')) ritualFollow();
  });
  ritualFollow();

  var box = root.querySelector('[data-sx-costs]');
  if (!box) return;
  var rate = parseFloat(box.getAttribute('data-rate')) || 0;
  var cards = box.querySelectorAll('[data-sx-heater]');
  var freq = root.querySelector('[data-sx-freq]');
  var freqOut = root.querySelector('[data-sx-freq-out]');

  function money(p, dp) {
    var n = p / 100;
    return '£' + (dp ? n.toFixed(2) : Math.round(n).toLocaleString('en-GB'));
  }

  function costs() {
    var perWeek = freq ? parseInt(freq.value, 10) || 3 : 3;
    if (freqOut) freqOut.textContent = perWeek;
    Array.prototype.forEach.call(cards, function (c) {
      var kw = parseFloat(c.getAttribute('data-kw'));
      if (!kw || c.getAttribute('data-wood') === '1') return;
      var session = kw * (parseFloat(c.getAttribute('data-h')) || 1.25) * rate;
      var s = c.querySelector('[data-o="session"]');
      var m = c.querySelector('[data-o="month"]');
      if (s) s.textContent = money(session, true);
      if (m) m.textContent = money(session * perWeek * 52 / 12, false);
    });
  }

  function chosen() {
    if (!document.querySelector('.ol-sauna-heater__input')) return;
    var picked = document.querySelector('.ol-sauna-heater__input:checked');
    var id = picked ? picked.value : '';
    Array.prototype.forEach.call(cards, function (c) {
      c.classList.toggle('is-chosen', !!id && c.getAttribute('data-sx-heater') === id);
    });
  }

  if (freq) freq.addEventListener('input', costs);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ol-sauna-heater__input')) chosen();
  });
  costs();
  chosen();
}());
